import BkButton from '../../../Components/ui/BkButton';

export type BoardFallbackProps = {
  preview?: boolean;
  onReload: () => void;
};

export default function BoardFallback({ preview, onReload }: BoardFallbackProps) {
  if (preview) {
    return <div className="h-full w-full bg-bk-bg" role="presentation" />;
  }

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-bk-bg px-4 text-center">
      <p className="text-sm text-bk-muted">The board failed to load.</p>
      <BkButton type="button" variant="secondary" size="sm" onClick={onReload}>
        Reload
      </BkButton>
    </div>
  );
}
